<template>

    <div class='container'>
        <div class='columns'>
            <div class='column is-3'></div>
            <div class='column is-8'>

                <div class='box'>

                    <h3 class='title is-5'>Profile Card</h3>
                    <cropper
                        context="user"
                        :width="384"
                        :height="384"
                        @uploadSuccess="uploadSuccess"
                        @uploadFailure="uploadFailure"
                    />

                    <!-- <img id='profile-image' v-bind:src="user.image[0].sizes.profileImage" alt="User profile picture"> -->

                    <br/><br/>

                    <b-field label='First name'>
                        <b-input type='text' v-model="user.firstName"></b-input>
                    </b-field>

                    <b-field label='Last name'>
                        <b-input type='text' v-model="user.lastName"></b-input>
                    </b-field>

                    <b-field label='About me'>
                        <b-input type='textarea' v-model="user.aboutMe"></b-input>
                    </b-field>

                    <hr/>

                    <h3 class='title is-5'>Summary</h3>
                    <b-field>
                        <b-input type='textarea' v-model="user.summary"></b-input>
                    </b-field>

                    <hr />

                    <h3 class='title is-5'>
                        <b-icon icon="certificate"></b-icon>
                        Studying
                    </h3>
                    <b-field label="Tell others what you study">
                        <b-taginput
                            v-model="user.studies"
                            :data="filteredStudies"
                            field="name"
                            autocomplete
                            allow-new="true"
                            icon="plus"
                            placeholder="Search for a major"
                            @typing="getFilteredStudies">
                        </b-taginput>
                    </b-field>

                    <hr />

                    <h3 class='title is-5'>
                        <b-icon icon="lightbulb-on-outline"></b-icon>
                        Interests
                    </h3>
                    <b-field label="What sort of topics or ideas interest you?">
                        <b-taginput
                            v-model="user.interests"
                            :data="filteredInterests"
                            autocomplete
                            allow-new="true"
                            icon="plus"
                            placeholder="Add a new interest"
                            @typing="getFilteredInterests">
                        </b-taginput>
                    </b-field>

                    <hr />

                    <a
                      class="button is-medium is-pulled-right"
                      :class="{ 'is-primary': saveResult == 'none', 'is-success': saveResult == 'success', 'is-danger': saveResult == 'error', 'is-loading': isSaving }"
                      @click='save()'>
                        Save
                    </a>

                    <span class='is-clearfix'></span>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
// See: https://buefy.github.io/documentation/taginput
const suggestedInterests = ['abc', 'abcde', 'def', 'ghi']; //require('@/data/sample.json')
const suggestedStudies = ['Computer Science', 'Physics', 'Psychology']; //require('@/data/sample.json')

export default {
  name: 'User',
  data () {
    return {
        user: {
          firstName: 'First',
          lastName: 'Last',
          aboutMe: 'This text is a placeholder.',
          image: 'https://placehold.it/96x96'
        },
        filteredInterests: suggestedInterests,
        filteredStudies: suggestedStudies,
        isSaving: false,
        saveResult: 'none' // 'success', 'error'
    }
  },
  mounted: function() {
    this.$http.get(this.$hostname + '/user/' + this.$route.params.username).then(function(response) {
      this.user = response.body;
    });

    this.$http.get(this.$hostname + '/user/' + this.$route.params.username + '/university').then(function(response) {
      this.university = response.body;
      this.university.routeLink = '/u/' + this.university.slug;
    });
  },
  methods: {
      getFilteredInterests(text) {
          this.filteredInterests = suggestedInterests.filter((option) => {
              return option
                  .toString()
                  .toLowerCase()
                  .indexOf(text.toLowerCase()) >= 0
          })
      },
      getFilteredStudies(text) {
          this.filteredStudies = suggestedStudies.filter((option) => {
              return option.name
                  .toString()
                  .toLowerCase()
                  .indexOf(text.toLowerCase()) >= 0
          })
      },
      sendEditUserRequest: function(data) {
          this.$http.post(this.$hostname + '/user/' + this.$route.params.username + '/edit', data).then(function(response) {
              this.isSaving = false;

              setTimeout(() => { // reset save result after a while
                  this.saveResult = 'none'
              }, 2000);

              this.saveResult = 'success'
              this.$toast.open({
                message: 'Saved your profile successfully!',
                type: 'is-success',
                queue: false
              })

              // Update $root which displays username in nav bar
              this.$root.user.firstName = this.user.firstName;
              this.$root.user.lastName = this.user.lastName;
          }, function(error) {
              this.isSaving = false;

              setTimeout(() => { // reset save result after a while
                  this.saveResult = 'none'
              }, 5000);

              this.saveResult = 'error'
              this.$toast.open({
                message: 'Error saving profile. Please try again or contact an administrator.',
                duration: 5000,
                type: 'is-danger',
                queue: false
              })
          });
      },
      uploadSuccess: function(imageRecord) {
          this.sendEditUserRequest({ image: imageRecord.uuid });
          this.$root.user.image = [ imageRecord ] ;
      },
      uploadFailure: function(error) {
          this.$toast.open({
            message: 'Could not upload image. Please try again!',
            type: 'is-error',
            queue: false
          })
      },
      save() {
        let formattedStudies = this.user.studies.slice(0) // make a fresh copy
        let updatedData = {
          firstName: this.user.firstName,
          lastName:  this.user.lastName,
          aboutMe:   this.user.aboutMe,
          summary:   this.user.summary,
          studies:   formattedStudies.map((study) => {
            if(typeof study === 'object') {
              return {
                name: study.name,
                type: study.type
              }
            }
            else {
              return {
                name: study,
                type: 'major' // TODO: update this to support major/minor
              }
            }
          }),
          interests: this.user.interests,
        };

        this.isSaving = true
        this.saveResult = 'none'
        this.sendEditUserRequest(updatedData);
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/UserEdit.vue